import { Customer, InterestInput, SearchIntentInput } from '__generated__/api';
import { CustomerInterest } from 'models/common/customer-interest';
import { ContextStore } from 'node_modules/bernie-core';
import { getBexApiContext } from 'bernie-graphql';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const getCustomerIntentInput = (context: ContextStore, semdtl: string): Customer.Variables => ({
  context: getBexApiContext(context),
  semdtl
});

export const mapCustomerInterests = (query: Customer.Query): CustomerInterest[] =>
  query.customer.currentTripIntent.why.interests.map(mapCustomerInterestType);

const mapCustomerInterestType = (customerInterest: Customer.Interests): CustomerInterest => ({
  desmetId: customerInterest.desmetId,
  name: customerInterest.name
});

const mapInterestInputType = (customerInterest: CustomerInterest): InterestInput => ({
  desmetId: customerInterest.desmetId,
  name: customerInterest.name
});

const getCustomerInterest = (customerInterests: CustomerInterest[]): InterestInput[] =>
  customerInterests && customerInterests.map(mapInterestInputType);

export const getSearchIntentInput = (customerInterests: CustomerInterest[], searchCriteria: SearchCriteriaModel): SearchIntentInput => {
  const interestInputs = getCustomerInterest(customerInterests);

  return {
    interests: interestInputs,
    semdtl: searchCriteria.semdtl || null,
    theme: searchCriteria.theme || null,
    userIntent: searchCriteria.userIntent || null
  };
};
